/* eslint-disable import/no-anonymous-default-export */
import axios, { Axios, AxiosError } from "axios";
import useApi, { ActionResult, Api, Model, Query } from "../common/hooks/useApi"
import { EstadisticasViewerData } from "./components/EstadisticasViewer";

const module = "Estadisticas";

const getFileName = (contentDisposition: any) => {
    let filename = 'estadisticas.csv';

    if (contentDisposition && contentDisposition.includes('filename')) {
        filename = contentDisposition
            .split('filename=')[1]
            .split(';')[0]
            .replace(/['"]/g, '');
    }

    return filename;
}

export type EstadisticaData = { key: number, value: number };

export default () => {
    const api = useApi({ module });

    return {
        getEstadisticasInfracciones: async (query?: Query, tipoFiltro?: ('AÑO' | 'MES' | 'DIA'), propFecha?:string): Promise<ActionResult<EstadisticaData[]>> => {
            try {
                let qs = api.queryToString(query ?? {});
                const response = await api.axiosInstance.get(`${module}/InfraccionesEstadistica?TipoDeFiltro=${tipoFiltro}&propFecha=${propFecha ?? 'CreatedAt'}&${qs}`);
                return {
                    data: { value: response.data }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        // sendEstadisticasToExcel: async (equipoId: number,tipoFiltro?: ('AÑO' | 'MES' | 'DIA'), anio?:number, mes? :number , propFecha?:string) => {
        //     try {
        //         const response = await api.axiosInstance.post(`${module}/ExportarEstadisticas?TipoDeFiltro=${tipoFiltro}&propFecha=${propFecha ?? 'CreatedAt'}&Anio=${anio}&Mes=${mes}&EquipoId=${equipoId}`);
        //         return {
        //             data: { value: response.data }
        //         };
        //     } catch (error: any | AxiosError) {
        //         return {
        //             error
        //         };
        //     }
        // }
        sendEstadisticasToExcel: async (estadisticasAnio : string, estadisticasMes : string, estadisticasDia : string, month : number, year : number, equipoId : number) => {
            try {
                axios({
                    url: `${api.baseAxiosConfig.baseURL}/${module}/ExportarEstadisticas`,
                    method: 'POST',
                    data: {
                        estadisticasAnio: estadisticasAnio,
                        estadisticasMes: estadisticasMes,
                        estadisticasDia: estadisticasDia,
                        month: month,
                        year: year,
                        equipoId: equipoId
                    },
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem("_token")}`,
                    },
                    responseType: 'blob',
                }).then((response)=>{
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
            
                    link.setAttribute('download', getFileName(response.headers['content-disposition']));
            
                    document.body.appendChild(link);
                    link.click();
            
                    // Limpiar el DOM
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url); // Liberar la URL creada
                }).catch((error) => {
                    console.error("Error descargando el archivo CSV:", error);
                });
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        }
    }
}